import { render } from "./PerPage.vue?vue&type=template&id=306cac1c"
import script from "./PerPage.vue?vue&type=script&lang=js"
export * from "./PerPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\deploy\\fire-conference\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__